module.exports = __webpack_public_path__ + "img/menuicon-101-active.3c76d101.png";